import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { whatsappUrl } from '../utils/whatsapp';
import { trackWhatsAppClick } from '../utils/analytics';
type Variant = 'primary' | 'dark' | 'outline' | 'white';
type Size = 'md' | 'lg';
interface WhatsAppButtonProps {
  message: string;
  label: string;
  /** Dónde vive el botón, para el evento de conversión */
  location: string;
  /** Intención del clic, para segmentar campañas */
  intent?: string;
  variant?: Variant;
  size?: Size;
  fullWidth?: boolean;
  className?: string;
}
const VARIANTS: Record<Variant, string> = {
  primary: 'bg-accent-500 text-white hover:bg-accent-600 focus-visible:outline-accent-500',
  dark: 'bg-navy-800 text-white hover:bg-navy-700 focus-visible:outline-navy-800',
  outline: 'bg-white text-navy-800 border border-steel-200 hover:border-navy-600 hover:text-navy-700 focus-visible:outline-navy-600',
  white: 'bg-white text-navy-800 hover:bg-steel-100 focus-visible:outline-white'
};
const SIZES: Record<Size, string> = {
  md: 'px-5 py-3 text-[15px]',
  lg: 'px-7 py-4 text-base sm:text-lg'
};
export function WhatsAppButton({
  message,
  label,
  location,
  intent = 'cotizacion',
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = ''
}: WhatsAppButtonProps) {
  return <a href={whatsappUrl(message)} target="_blank" rel="noopener noreferrer" onClick={() => trackWhatsAppClick(location, intent)} className={['inline-flex items-center justify-center gap-2 rounded-md font-semibold', 'transition-[background-color,border-color,transform,box-shadow] duration-150 ease-out', 'active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2', VARIANTS[variant], SIZES[size], fullWidth ? 'w-full' : '', className].join(' ')} data-id="element-298" data-mp="mc4hyqviro7o">
      <MessageCircleIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-299" data-mp="372lo42iselku" />
      <span data-id="element-300" data-mp="370ipiu3kjk4i">{label}</span>
    </a>;
}